
import { supabase } from './supabaseClient';
import { FichaTecnica, FichaTecnicaItem } from '../types';

export const fichaTecnicaService = {
  async getFichaTecnicaByProduto(produtoId: string): Promise<FichaTecnica | null> {
    const { data, error } = await supabase
      .from('fichas_tecnicas')
      .select('*, itens:ficha_tecnica_itens(*, insumo:insumos(*, unidade_medida:unidades_medida(*)))')
      .eq('produto_id', produtoId)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async salvarFichaTecnica(ficha: Partial<FichaTecnica>): Promise<FichaTecnica> {
    const { data, error } = await supabase
      .from('fichas_tecnicas')
      .upsert(ficha)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async salvarItemFichaTecnica(item: Partial<FichaTecnicaItem>): Promise<FichaTecnicaItem> {
    const { data, error } = await supabase
      .from('ficha_tecnica_itens')
      .upsert(item)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async removerItemFichaTecnica(id: string): Promise<void> {
    const { error } = await supabase
      .from('ficha_tecnica_itens')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },

  async recalcularCusto(p_ficha_tecnica_id: string): Promise<void> {
    const { error } = await supabase.rpc('calculate_ficha_tecnica_cost', {
      p_ficha_tecnica_id
    });

    if (error) throw error;
  },

  async validarEstoqueProduto(p_produto_id: string, p_quantidade: number): Promise<boolean> {
    const { data, error } = await supabase.rpc('validar_estoque_produto', {
      p_produto_id,
      p_quantidade
    });

    if (error) throw error;
    return data;
  }
};
